/**
 * Settings for the hosted relays people actually use, so nobody has to go
 * and look up a host name — and so the two mistakes everyone makes once
 * (wrong port for the encryption, wrong kind of secret) are pre-empted.
 */
export interface RelayPreset {
  id: string;
  name: string;
  host: string;
  port: number;
  secure: boolean;
  /** What the username field wants, in that provider's own terms */
  username: string;
  /** What the password field wants */
  password: string;
  /** What the from address has to be */
  sender: string;
}

export const RELAY_PRESETS: RelayPreset[] = [
  {
    id: 'brevo',
    name: 'Brevo',
    host: 'smtp-relay.brevo.com',
    port: 587,
    secure: false,
    username: 'The SMTP login on Brevo’s "SMTP & API" page — it looks like 8a1b2c001@smtp-brevo.com, not your account email.',
    password: 'An SMTP key created on that same page, not your Brevo password.',
    sender: 'A sender Brevo has verified under "Senders, domains & dedicated IPs".',
  },
  {
    id: 'sendgrid',
    name: 'SendGrid',
    host: 'smtp.sendgrid.net',
    port: 587,
    secure: false,
    username: 'The literal word "apikey".',
    password: 'An API key with Mail Send permission.',
    sender: 'A verified sender identity.',
  },
  {
    id: 'mailgun',
    name: 'Mailgun',
    host: 'smtp.mailgun.org',
    port: 587,
    secure: false,
    username: 'The SMTP username for your sending domain.',
    password: "That domain's SMTP password.",
    sender: 'An address on a verified sending domain.',
  },
  {
    id: 'gmail',
    name: 'Gmail',
    host: 'smtp.gmail.com',
    port: 587,
    secure: false,
    username: 'Your full Gmail address.',
    password: 'An app password, not your Google account password.',
    sender: 'The same Gmail address, or an alias it may send as.',
  },
];

/** Which preset a saved host belongs to, so the form opens where the user left it */
export const presetForHost = (host: string): RelayPreset | undefined => {
  const value = (host ?? '').trim().toLowerCase();
  if (!value) return undefined;
  if (/brevo|sendinblue/.test(value)) return RELAY_PRESETS[0];
  return RELAY_PRESETS.find((preset) => preset.host === value);
};
